module.exports = __webpack_public_path__ + "img/m-wthd-logo.df46b4f7.png";